import { Theme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/styles';

import { useAppMediaQuery } from 'src/hooks/app/useAppMediaQuery';
import useWindowDimensions from './use-window-dimensions';

export const useIsMobile = () => {
  const theme: Theme = useTheme();
  const { isXlUp } = useAppMediaQuery();
  const { windowDimensions } = useWindowDimensions();
  const [isMobileScreen, setIsMobile] = useState<boolean>(false);
  const [isXlScreen, setXlScreen] = useState<boolean>(false);
  const [isWideScreen, setIsWideScreen] = useState<boolean>(false);

  useEffect(() => {
    if (windowDimensions.width <= theme.breakpoints.values.md && !isMobileScreen) {
      setIsMobile(true);
    }

    if (windowDimensions.width > theme.breakpoints.values.md && isMobileScreen) {
      setIsMobile(false);
    }

    setIsWideScreen(windowDimensions.width >= 2560);

    setXlScreen(isXlUp);
  }, [isXlUp, isMobileScreen, windowDimensions, theme.breakpoints.values.md]);

  return {
    isXlScreen,
    isMobileScreen,
    isWideScreen,
  };
};
